export default {
  serverBase: 'https://api.icezu.com/movie/',
  pagingLimit: 20,
  cacheTime: 3600,
};
